import { render } from "./BanobagiTransactionSummary.vue?vue&type=template&id=c3674dac&scoped=true"
import script from "./BanobagiTransactionSummary.vue?vue&type=script&lang=js"
export * from "./BanobagiTransactionSummary.vue?vue&type=script&lang=js"

import "./BanobagiTransactionSummary.vue?vue&type=style&index=0&id=c3674dac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3674dac"]])

export default __exports__